import { ArrowBack, ArrowForward } from '@mui/icons-material'
import { Box, Button, Container, useMediaQuery, useTheme } from '@mui/material'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { AppBarLocalizationMenu } from 'src/services/public/layout/components/navigation-bar/components/localization'
import { MapitCopyRight } from 'src/services/shared/components'
// import { Group } from "../../public/layout/components/navigation-bar/assets"
import Logo from 'src/services/shared/components/Logo';
import Cubs from "src/services/auth/assets/Cubs.svg"

export default function AuthLayout() {
    const { t } = useTranslation()
    const theme = useTheme()

    const navigate = useNavigate()

    const location = useLocation()

    const isBaseAuthPage = useMemo(() => {
        if (["/auth/general", "/auth/general/register"].includes(location.pathname)) {
            return true
        }
        return false
    }, [location.pathname])

    const isDownMd = useMediaQuery(theme.breakpoints.down("md"))

    return (
        <Box
            bgcolor="primary.main"
            height="100vh"
            display="flex"
            overflow="auto"
            position="relative"
            justifyContent="center"
            sx={{
                backgroundImage: `url(${Cubs})`,
                backgroundSize: "cover", // or "contain" based on your requirement
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                overflow: "auto",
            }}
        >
            {/* <img
                src={Cubs}
                alt="Cubs"
                style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    minHeight: "100%",
                    objectFit: "cover",
                    overflow: "auto",
                }} /> */}
            {
                !isDownMd &&
                <Logo
                    type='light'
                    style={{
                        cursor: "pointer",
                        // height: "76px"
                        height: "52px",
                        position: "absolute",
                        top: "35px",
                        left: "50%",
                        transform: "translateX(-50%)",

                    }}
                    onClick={_ => { navigate("/", { replace: true }) }}
                />
            }
            <Container maxWidth="xl" sx={{ mx: { xl: 10, lg: 10, md: 4, sm: 0, xs: 0 } }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    height="100%"
                >

                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={{ xs: "20px", md: "40px" }}>
                        <Button
                            startIcon={
                                theme.direction === "rtl"
                                    ?
                                    <ArrowForward />
                                    :
                                    <ArrowBack />
                            }
                            color="white"
                            sx={{ textTransform: "none", fontSize: "14px" }}
                            onClick={() => {
                                if (isBaseAuthPage) {
                                    navigate('/')
                                } else {
                                    navigate(-1)
                                }
                            }}
                        >
                            {isBaseAuthPage ? t("Back to Home") : t("Back")}
                        </Button>
                        <AppBarLocalizationMenu reload={false} />
                    </Box>
                    {
                        isDownMd &&
                        <Logo
                            type='light'
                            style={{
                                cursor: "pointer",
                                // height: "76px"
                                height: "52px"
                            }}
                            onClick={_ => { navigate("/", { replace: true }) }}
                        />
                    }

                    <Outlet />

                    <Box textAlign="center" mt="auto">
                        <MapitCopyRight />
                    </Box>

                </Box>

            </Container>
        </Box>
    )
}
